<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div *ngIf="isPageReady" class="flex flex-col gap-3 mt-2">

    <!-- Header context -->
    <div class="text-sm">
      Setting up QBO link for Uniformax account
      <strong>{{ account.accountName }}</strong>
      (Id {{ account.id }}). Search for an existing QuickBooks customer to link, or create a new one.
    </div>

    <!-- Search section -->
    <div class="qb-detail-card p-3">
      <div class="font-semibold text-base mb-2 uppercase tracking-wide">Search existing QBO customers</div>

      <div class="flex flex-row gap-2 items-end">
        <uni-field label="Search (min 3 chars)" class="flex-1">
          <input
            #searchInput
            pInputText
            [(ngModel)]="searchQuery"
            (keydown.enter)="runSearch()"
            title="Search"
          />
        </uni-field>
        <button
          pButton
          type="button"
          class="p-button-raised p-button-sm"
          icon="pi pi-search"
          [disabled]="isSearching"
          (click)="runSearch()">
          <span>{{ isSearching ? 'Searching...' : 'Search' }}</span>
        </button>
      </div>

      <div *ngIf="searchError" class="mt-2 text-sm" style="color: var(--p-red-500, #ef4444)">
        {{ searchError }}
      </div>

      <div *ngIf="hasSearched && !isSearching && !searchError" class="mt-3">
        <div *ngIf="searchResults.length === 0" class="text-sm italic">
          No QBO customers matched. Try a shorter search, or create a new customer below.
        </div>

        <table *ngIf="searchResults.length > 0" class="qb-info-table w-full">
          <thead>
            <tr>
              <th class="label" style="text-align: left; padding: 4px 8px">Display Name</th>
              <th class="label" style="text-align: left; padding: 4px 8px">Company Name</th>
              <th class="label" style="text-align: left; padding: 4px 8px">Status</th>
              <th class="label" style="text-align: right; padding: 4px 8px"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let row of searchResults"
              [style.opacity]="isRowLinkable(row) ? 1 : 0.55"
              [style.background]="isRowLinkable(row) ? null : 'var(--p-surface-100, #f1f5f9)'">
              <td style="padding: 4px 8px">{{ row.DisplayName }}</td>
              <td style="padding: 4px 8px">{{ row.CompanyName || '—' }}</td>
              <td style="padding: 4px 8px; font-size: 0.85em">{{ rowLinkedNote(row) || 'Available' }}</td>
              <td style="padding: 4px 8px; text-align: right">
                <button
                  pButton
                  type="button"
                  class="p-button-sm p-button-raised"
                  icon="pi pi-link"
                  [disabled]="!isRowLinkable(row)"
                  (click)="linkTo(row)">
                  <span>Link (Id {{ row.Id }})</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Create section -->
    <div class="qb-detail-card qb-primary-tint p-3">
      <div class="font-semibold text-base mb-2 uppercase tracking-wide">Or create a new QBO customer</div>
      <div class="text-sm mb-2">
        Only use this if no existing customer above matches. QuickBooks will reject a duplicate Display Name.
      </div>

      <div class="flex flex-row gap-3">
        <uni-field label="Display Name" class="flex-1">
          <input pInputText [(ngModel)]="createDisplayName" title="Display Name" />
        </uni-field>
        <uni-field label="Company Name" class="flex-1">
          <input pInputText [(ngModel)]="createCompanyName" title="Company Name" />
        </uni-field>
        <div class="flex items-end">
          <button
            pButton
            type="button"
            class="p-button-raised p-button-sm"
            icon="pi pi-plus"
            [disabled]="isCreating"
            (click)="createNew()">
            <span>{{ isCreating ? 'Creating...' : 'Create' }}</span>
          </button>
        </div>
      </div>

      <div *ngIf="createError" class="mt-2 text-sm" style="color: var(--p-red-500, #ef4444)">
        {{ createError }}
      </div>
    </div>

  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button (click)="cancel()" pButton type="button" class="p-button-raised">
      <span>Close</span>
    </button>
  </div>
</ng-template>
